import { alpha } from '@mui/material/styles';
import { ICustomTheme } from '../types/ICustomTheme';

export const LightPalette: ICustomTheme['palette'] = {
     mode: 'light',
     primary: {
          main: '#2563eb', // Blue-600 - mais profundo e elegante
          light: alpha('#2563eb', 0.8),
          dark: '#1d4ed8',
          contrastText: '#FFFFFF',
     },
     secondary: {
          main: '#0891b2', // Cyan-600 - mais equilibrado no light
          light: alpha('#0891b2', 0.8),
          dark: '#06b6d4',
          contrastText: '#FFFFFF',
     },
     tertiary: {
          main: '#d97706', // Amber-600 - melhor contraste
          light: alpha('#d97706', 0.8),
          dark: '#b45309',
          contrastText: '#FFFFFF',
     },
     alternate: {
          main: '#f1f5f9', // Slate-100 - muito mais suave
          light: alpha('#f1f5f9', 0.8),
          dark: '#e2e8f0',
          contrastText: '#1e293b',
     },
     text: {
          primary: '#0f172a', // Slate-900 - mais suave que preto puro
          secondary: '#475569', // Slate-600 - melhor legibilidade
     },
     background: {
          paper: '#ffffff', // Branco puro para cards
          default: '#f8fafc', // Slate-50 - fundo muito sutil
     },     accent1: {
          main: 'rgba(37, 99, 235, 0.08)', // Primary com transparência muito sutil
          light: 'rgba(37, 99, 235, 0.05)',
          dark: 'rgba(37, 99, 235, 0.12)',
          contrastText: '#1e293b',
     },
     accent2: {
          main: 'rgba(8, 145, 178, 0.08)', // Secondary com transparência
          light: 'rgba(8, 145, 178, 0.05)',
          dark: 'rgba(8, 145, 178, 0.12)',
          contrastText: '#1e293b',
     },
     accent3: {
          main: 'rgba(217, 119, 6, 0.08)', // Tertiary com transparência
          light: 'rgba(217, 119, 6, 0.05)',
          dark: 'rgba(217, 119, 6, 0.12)',
          contrastText: '#1e293b',
     },
     accent4: {
          main: 'rgba(241, 245, 249, 0.70)', // Alternate com transparência
          light: 'rgba(241, 245, 249, 0.50)',
          dark: 'rgba(241, 245, 249, 0.90)',
          contrastText: '#1e293b',
     },     // Cores modernas aprimoradas para light theme
     info: {
          main: '#0ea5e9', // Sky-500 - consistente com dark
          light: alpha('#0ea5e9', 0.8),
          dark: '#0284c7',
          contrastText: '#FFFFFF',
     },
     neutral: {
          main: '#64748b', // Slate-500 - equilibrado
          light: alpha('#64748b', 0.8),
          dark: '#475569',
          contrastText: '#FFFFFF',
     },
     pastel1: {
          main: '#93c5fd', // Blue-300 - pastel mais claro para light
          light: alpha('#93c5fd', 0.8),
          dark: '#60a5fa',
          contrastText: '#1e40af',
     },
     pastel2: {
          main: '#c4b5fd', // Violet-300 - pastel suave
          light: alpha('#c4b5fd', 0.8),
          dark: '#a78bfa',
          contrastText: '#7c3aed',
     },
     pastel3: {
          main: '#fda4af', // Rose-300 - rosa suave
          light: alpha('#fda4af', 0.8),
          dark: '#fb7185',
          contrastText: '#be123c',
     },
     vibrant1: {
          main: '#dc2626', // Red-600 - vibrante mas não excessivo
          light: alpha('#dc2626', 0.8),
          dark: '#b91c1c',
          contrastText: '#FFFFFF',
     },
     vibrant2: {
          main: '#059669', // Emerald-600 - verde vibrante
          light: alpha('#059669', 0.8),
          dark: '#047857',
          contrastText: '#FFFFFF',
     },
     vibrant3: {
          main: '#ea580c', // Orange-600 - laranja equilibrado
          light: alpha('#ea580c', 0.8),
          dark: '#c2410c',
          contrastText: '#FFFFFF',
     },
     error: {
          main: '#dc2626', // Red-600 mais suave
     },
     warning: {
          main: '#d97706', // Amber-600 melhor contraste
     },
     success: {
          main: '#059669', // Emerald-600 mais vibrante
     },
     divider: '#e2e8f0', // Slate-200 - divisor sutil
};
